import 'react-notifications/lib/notifications.css';
import {NotificationManager} from 'react-notifications';
import {auth} from "../../../firebase";
import {isEmailVerified} from "../../../firebase/auth";

/**
 * This file controls and manages all live notifications that are pushed directly into the system.
 * For more information and API, visit {@link https://www.npmjs.com/package/react-notifications}
 */

const TIMEOUT = 10000;
const TIMEOUT_MAX = 0;

const MESSAGE_SUCCESS = 'Success';
const MESSAGE_ERROR = 'Error';
const MESSAGE_COPIED = 'Copied';
const MESSAGE_NOT_COPIED = 'Not Copied';
const MESSAGE_EMAIL_UNVERIFIED = 'Unverified Email';
const MESSAGE_EMAIL_SENT = 'Email Sent';
const MESSAGE_EMAIL_NOT_SENT = 'Email Not Sent';
const MESSAGE_RECORDING_READ  = 'Recording Read';


/* -----------------    Account Management     ------------------ */
/** The notification to be shown when password is successfully changed */
export const showChangePasswordSuccessNotification = () =>
    NotificationManager.success("Password Successfully Changed", MESSAGE_SUCCESS, TIMEOUT);

/** The notification to be shown when password is not changed */
export const showChangePasswordFailureNotification = () =>
    NotificationManager.error("Password change failed", MESSAGE_ERROR, TIMEOUT);

/** The notification to be shown when profile info is successfully saved */
export const showChangeProfileInfoSuccessNotification = () =>
    NotificationManager.success("Profile Information Successfully Saved. Reload to see new changes.",
        MESSAGE_SUCCESS, TIMEOUT, () => {window.location.reload();});

/** The notification to be shown when profile info is not saved */
export const showChangeProfileInfoFailureNotification = () =>
    NotificationManager.error("Profile Information was not able to be saved", MESSAGE_ERROR, TIMEOUT);

/** The notification to be shown when the email has not been verified */
export const showEmailNotVerifiedNotification = (authUser) => {
    if (!isEmailVerified()) {
        NotificationManager.create({
            id: UNVERIFIED_EMAIL_INSTANCE_ID,
            type: 'error',
            message: 'Your email, ' + authUser.email + ', has not been verified. ' +
            'Please verify your email before proceeding. If you have not ' +
            'received a verification email, click on this message to ' +
            'send it again.',
            title: MESSAGE_EMAIL_UNVERIFIED,
            timeOut: TIMEOUT_MAX,
            onClick: () => {
                auth.doSendEmailVerification()
                    .then(() => {
                        showVerifyEmailSentNotification(authUser);
                    })
                    .catch(error => {
                        showVerifyEmailNotSentNotification(authUser.email);
                        console.log(error);
                    });
                setTimeout(() => {
                    showEmailNotVerifiedNotification(authUser);
                }, TIMEOUT * 2);

            },
            priority: true
        });
    }
};

/** The notification instance id of the unverified email notification.
 * NOTE: Helps us to manually clear notifications */
const UNVERIFIED_EMAIL_INSTANCE_ID = 1;

const clearVerifyEmailNotification = () => {
    NotificationManager.remove({id: UNVERIFIED_EMAIL_INSTANCE_ID});
};

/** The notification to be shown when the verification email has been resent */
export const showVerifyEmailSentNotification = (authUser) =>
    NotificationManager.info('An email has been sent to ' + authUser.email + '. Please verify ' +
        'your email before proceeding. Please wait a few minutes and/or ' +
        'check your spam folder if you have not received it yet.',
        MESSAGE_EMAIL_SENT, TIMEOUT);

/** The notification to be shown when the verification email cannot be resent */
export const showVerifyEmailNotSentNotification = (email) =>
    NotificationManager.info('A verification email was not able to be sent to ' + email + ' at this ' +
        'time. Please try again in a few minutes. If this problem persists, contact us for help.',
        MESSAGE_EMAIL_NOT_SENT, TIMEOUT);


/* -----------------    Recording Management     ------------------ */
/** The notification to be shown when a recording edit is successfully saved */
export const showEditRecordingSavedSuccessNotification = () =>
    NotificationManager.success("Recording Successfully Saved", MESSAGE_SUCCESS, TIMEOUT);

/** The notification to be shown when a recording edit failed to saved */
export const showEditRecordingSavedFailureNotification = () =>
    NotificationManager.error("Recording Failed to be Saved", MESSAGE_ERROR, TIMEOUT);

/** The notification to be shown when a recording share link is copied to the clipboard */
export const showShareRecordingClipboardNotification = () =>
    NotificationManager.info("Link copied to clipboard", MESSAGE_COPIED, TIMEOUT);

/** The notification to be shown when a recording share link is copied to the clipboard */
export const showShareRecordingMakePublicFailureNotification = () =>
    NotificationManager.error("Recording was not able to be made public at this time", MESSAGE_NOT_COPIED, TIMEOUT);

/** The notification to be shown when a recording has been read */
export const showReadRecordingNotification = () =>
    NotificationManager.info(MESSAGE_RECORDING_READ);


/* -----------------    General     ------------------ */
/** Clears all notifications */
export const clearAllNotifications = () => {
    clearVerifyEmailNotification();
};



// WEBPACK FOOTER //
// ./src/components/notifications/live/index.js